module.exports = __webpack_public_path__ + "static/what-we-do-46a5fe3eb987d7c6fc4229bb30cceff4.webp";